import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoButton from 'eco-design/base/eco-button';

export default function Contact() {
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = getLocal();

    const linksArr: any = [
        {
            name: t('secG_na'),
            link: 'media.na@ecoflow.com',
        },
        {
            name: t('secG_eu'),
            link: 'media.eu@ecoflow.com',
        },
        {
            name: t('secG_jp'),
            link: 'media.jp@ecoflow.com',
        },
        {
            name: t('secG_ap'),
            link: 'media.apac@ecoflow.com',
        },
        {
            name: t('secG_lamea'),
            link: 'media.lamea@ecoflow.com',
        },
    ];

    return (
        <div className={`${styles.Contact} GtmModuleData-section`}>
            <div className="pfa-layout contact-wrapper">
                <div className="left-wrapper">
                    <div className="powerforall-header">
                        <div className="title">{t('secG_title')}</div>
                        <div className="desc">{t('secG_desc')}</div>
                    </div>

                    <EcoButton lHref={`mailto:media.na@ecoflow.com`} lRadius="ellipse" lTheme="black">
                        Contact Us
                    </EcoButton>
                </div>
                <div className="right-wrapper">
                    {linksArr.map((item: any) => (
                        <div className="link-item" key={item.name}>
                            <div className="link-item-name">{item.name}</div>
                            <a href={`mailto:${item.link}`} className="link-item-link">
                                {item.link}
                            </a>
                        </div>
                    ))}
                </div>

                <EcoButton lHref={`mailto:media.na@ecoflow.com`} className="contact-us-pad" lRadius="ellipse" lTheme="black">
                    Contact Us
                </EcoButton>
            </div>
        </div>
    );
}
